const Blazy = require('blazy');

export default () => {
    window.bLazy = new Blazy({
        offset: 0,
        selector: '.lazy',
        loadInvisible: true,
        breakpoints: [
            {
                width: 640, // max-width
                src: 'data-src-small',
            },
            {
                width: 1024, // max-width
                src: 'data-src-medium',
            },
        ],
    });

}

export const revalidateBLazy = () => {

    if (typeof window.bLazy !== 'undefined') {
        window.bLazy.revalidate();
    }

};
